/* Copyright (c) 2017 Backpack Health LLC */

function isNonEmptyString(text) {
  return text !== '' && text !== null && text !== undefined;
}

function validateEmail(value) {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(value);
}

function isNumericRange(range) {
  const regex = /^([0-9]+(\.[0-9]+)?)([-]([0-9]+(\.[0-9]+)?))?$/;
  if (!regex.test(range)) {
    return false;
  }

  const matches = regex.exec(range);
  const from = matches[1];
  const to = matches[4];
  return (from && to) ? parseFloat(from) <= parseFloat(to) : true;
}

export {
  validateEmail,
  isNumericRange,
};
